import { configureStore } from '@reduxjs/toolkit';
import category from './slices/category';
import product from './slices/product';
import loginRegister from './slices/loginRegister';
import addToCart from './slices/addToCart';
import address from './slices/address';
import user from './slices/user';
import wishlist from './slices/wishlist';
import initiaterazorpay from './slices/initiaterazorpay';
import contact from './slices/contactfrom';
import blog from './slices/blog';
import orders from './slices/orders';
import codorder from './slices/codorder';
import review from './slices/reviews';
import page from './slices/pageBuilderSlice';

const store = configureStore({
    reducer: {
        category,
        product,
        loginRegister,
        addToCart,
        address,
        user,
        wishlist,
        initiaterazorpay,
        contact,
        blog,
        orders,
        codorder,
        review,
        page,
    },
});

export const { dispatch } = store;

export default store;
